import type { ReactElement } from 'react';
import { CanvasNote } from './canvas-note';

interface FacePhotoOnlyProps {
  /** 지금 색상·면의 목업 사진. 없으면 안내만 보인다. */
  readonly url: string | null;
}

/** 인쇄 영역이 없는 면 — 목업 사진만 보여 주고 편집할 수 없다고 알린다. */
export const FacePhotoOnly = ({ url }: FacePhotoOnlyProps): ReactElement => (
  <div
    className="relative flex size-full items-center justify-center"
    data-testid="face-photo-only"
  >
    {url !== null && (
      <img
        src={url}
        alt=""
        aria-hidden
        draggable={false}
        className="max-h-full max-w-full object-contain"
      />
    )}
    <CanvasNote>이 면에는 인쇄 영역이 없어요</CanvasNote>
  </div>
);
